import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import * as Sentry from '@sentry/react'

import rootReducer from '../reducers'

const sentryEnhancer = Sentry.createReduxEnhancer()

function configureStore(initialState) {
  const middlewares = [
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
  ]

  const composeEnhancers =
    process.env.NODE_ENV === 'production'
      ? compose
      : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // add support for Redux dev tools
  const enhancer = composeEnhancers(applyMiddleware(...middlewares), sentryEnhancer)

  return createStore(rootReducer, initialState, enhancer)
}

export default configureStore
